module.exports = __webpack_public_path__ + "6aaf8c2f1c12c7672891293f6fcc7116.jpg";